
import { useNavigate } from 'react-router-dom';

interface ProductCardProps {
  id: string;
  name: string;
  description: string;
  price: string;
  image: string;
  destination: string;
}

export default function ProductCard({ id, name, destination, description, price, image }: ProductCardProps) {
  const navigate = useNavigate();

  return (
    <div 
      onClick={() => navigate(`/product/${id}`)}
      className="group cursor-pointer"
    >
      <div className="bg-[#132847] rounded-lg overflow-hidden hover:shadow-lg hover:shadow-black/30 transition-shadow relative">
        {/* Sold Out Overlay */}
        <div className="absolute top-2 right-2 sm:top-3 sm:right-3 z-10 bg-[#0B1B3A]/90 text-[#E8A0A0] text-xs font-medium px-2.5 py-1 rounded-full uppercase tracking-wider">
          Sold Out
        </div>
        <div className="aspect-square overflow-hidden bg-[#1A3358]">
          <img
            src={image}
            alt={name}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500 opacity-60"
          />
        </div>
        <div className="p-3 sm:p-6">
          <div className="flex items-center gap-1 mb-1 sm:mb-2">
            <i className="ri-map-pin-line text-[#6B83A8] text-xs"></i>
            <p className="text-xs tracking-widest text-[#6B83A8] uppercase">{destination}</p>
          </div>
          <h3 className="text-sm sm:text-lg font-serif text-[#F5F0E8] mb-1 sm:mb-2">{name}</h3>
          <p className="text-xs sm:text-sm text-[#8A9BB5] mb-2 sm:mb-3 line-clamp-2 hidden sm:block">{description}</p>
          <p className="text-sm sm:text-lg font-medium text-[#D4C5A9] mb-2 sm:mb-3 line-through opacity-50">{price}</p>
          <div className="w-full py-2 rounded-lg text-xs sm:text-sm font-medium bg-[#162D52] text-[#6B83A8] text-center cursor-not-allowed whitespace-nowrap">
            <i className="ri-close-circle-line mr-1"></i>
            Sold Out
          </div>
        </div>
      </div>
    </div>
  );
}
